import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const GroupAgentPreviewBannerIntegration = () =>
  import(/* webpackChunkName: "4-feat-group-agent-preview-banner" */ './GroupAgentPreviewBannerIntegration');

export const LoadableGroupAgentPreviewBanner = lazyLoadOnRender({ loader: GroupAgentPreviewBannerIntegration });
